import { jwtDecode } from 'jwt-decode';

/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserJwt = {
    id?: string;
    name?: string;
    email?: string;
};


export const getUserData = (token: string): UserJwt => jwtDecode(token);
